var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.id}},[_c('router-view',{attrs:{"html":_vm.home_template_src,"full":_vm.full_home_template_loaded}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }